import { IonIcon } from '@ionic/react';
import { hourglass } from 'ionicons/icons';
import React from 'react';

export default function KycUnderReview() {
  return (
    <div className="space-y-4 py-4">
      <div className="flex items-center justify-center gap-4">
        <IonIcon
          icon={hourglass}
          className="text-primary opacity-25 size-16 mx-auto"
        />

        <div className="flex-1">
          <h5 className="font-semibold high-emphasis-text">
            Request Under Review
          </h5>
          <p className="medium-emphasis-text">
            your kyc request will be processed soon
          </p>
        </div>
      </div>
    </div>
  );
}
